import { getLoginConfig } from '@/api/fetchConfig'
import store from '@/store'
import { importStyleByConfig } from '@/styles/style-manager.js'
export function getLoginConfigApi() {
  return getLoginConfig().then((response) => {
    if (response.code === 200) {
      store.commit('user/SET_CONFIG', response.data)
      return importStyleByConfig()
    }
    return Promise.reject(new Error('获取登录配置失败'))
  })
}
